import Transformer from '../transformer'
import AffectedTransformer from './AffectedTransformer'

/**
 * @autor Andrés Aguilar <andresyoshimar@gmail.com>
 */

export default class SinisterTransformer extends Transformer {
  static fetch(sinister) {
    return {
      ...sinister.cfdi,
      ...AffectedTransformer.fetch(sinister.affected),
      ...sinister.client,
    }
  }
  static send(sinister) {
    return {
      cfdi: {
        uuid: sinister.uuid,
        folio: sinister.folio,
        total: sinister.total,
      },
      affected: { ...AffectedTransformer.send({
        id: sinister.id,
        requisitionNumber: sinister.requisitionNumber,
        sinisterNumber: sinister.sinisterNumber,
        highway: sinister.highway,
      }) },
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/extranet/SinisterTransformer.js